import React from 'react'
import { Card, Col, Container } from 'reactstrap'
import { BackButton } from '../../components/Common/BackButton'
import Breadcrumb from '../../components/Common/Breadcrumb'
import baseUrl from '../../helpers/baseurl'

export const NormLibraryPDFViewer = (props) => {
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 20 }}>
                        <Card className='' style={{ padding: 50 }}>

                            <div className="d-flex align-items-center justify-content-between">
                                <Breadcrumb breadcrumbItem1='normLibrary' />
                                <BackButton props={props} />
                            </div>

                            <Card className='pb-4' style={{ padding: 20 }}>
                                <div className="ratio ratio-21x9">
                                    <iframe title="Biblioteca de Normas PDF" src={`${baseUrl}norms-library/image/${props?.match?.params?.file}#toolbar=0`} ></iframe>
                                </div>
                            </Card>
                        </Card>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    )
}
